import { render, staticRenderFns } from "./StartFlow.vue?vue&type=template&id=117e10d4&scoped=true"
import script from "./StartFlow.vue?vue&type=script&lang=js"
export * from "./StartFlow.vue?vue&type=script&lang=js"
import style0 from "./StartFlow.vue?vue&type=style&index=0&id=117e10d4&prod&lang=sass&scoped=true"
import style1 from "./StartFlow.vue?vue&type=style&index=1&id=117e10d4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e10d4",
  null
  
)

export default component.exports